import { AuthAxios } from "./AxiosInstances"

const createTicket = (ticket) => {
    return AuthAxios.post('support/ticket', ticket);
}

const GetMyTickets = (page) => {
    return AuthAxios.get('support/mytickets?page=' + page);
}

const GetTicket = (id) => {
    return AuthAxios.get('support/ticket/' + id);
}

const Reply = (id, message) => {
    return AuthAxios.post('support/ticket/' + id + "/reply", { message });
}

const MarkAsSolved = (id) => {
    return AuthAxios.put(`support/ticket/${id}/solve`);
}


const TicketsAPI = {
    createTicket,
    GetMyTickets,
    GetTicket,
    Reply,
    MarkAsSolved
}

export default TicketsAPI